import { useMediaQuery } from '@mui/material';

import { SVideo, SVideoPoster } from './styled';

type UpsellVideoProps = { mp4: string; poster: string; webm: string };

export const UpsellVideo = ({ mp4, poster, webm }: UpsellVideoProps) => {
  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  if (isReducedMotion) return <SVideoPoster alt="" data-testid="upsell-video-poster" src={poster} />;

  return (
    <SVideo data-testid="upsell-video" poster={poster} autoPlay loop muted playsInline>
      <source src={webm} type='video/webm; codecs="vp9"' />
      <source src={mp4} type="video/mp4" />
    </SVideo>
  );
};
